import Card from './Card'
import Checkbox from './Checkbox'
import Select from './Select'
import Input from './Input'

const registry = {
  Card,
  Checkbox,
  Select,
  Input,
}

export function getShopOptionComponent(optionType) {
  if (!optionType) return null

  const optionModule = String(optionType).replace(/\b\w/g, l => l.toUpperCase())
  return registry[optionModule] || null
}